<template>
  <div id="main" :class="{ mask: !isDeveloper }">
    <!-- $vi18n('$i18n# 页面切换 #i18n$') -->
    <div id="tab">
      <p
        class="btn-label"
        :class="{ 'p-chosen': activeLabel == index }"
        v-for="(label, index) in labelArr"
        :key="index"
        @click="changeLabel(index)"
      >
        {{ label }}
      </p>
    </div>
    <!-- $vi18n('$i18n# 分页 #i18n$') - $vi18n('$i18n# 数据总览 #i18n$') -->
    <div id="overview" v-show="!activeLabel">
      <div class="card-content">
        <div class="card-title">
          <div class="title-help">
            <p class="name">{{$vi18n('$i18n# 数据趋势总览 #i18n$')}}</p>
            <span class="help">
              <div class="help-tip">
                <HelpTip></HelpTip>
              </div>
              <div class="week-filter">
                <span class="desc">{{$vi18n('$i18n# 统计周期 #i18n$')}}：</span>
                {{ countTime }}
              </div>
            </span>
          </div>
        </div>
        <div class="complex-wrap" v-loading="loadingCharts">
          <!--$vi18n('$i18n# 作品数据 #i18n$')-->
          <div class="card-box">
            <div class="title">{{$vi18n('$i18n# 作品数据 #i18n$')}}</div>
            <div id="card">
              <cpn-cards
                v-for="(item, index) in productData"
                :key="index"
                :data="item"
                class="card-wrap"
                :class="{ 'active-card': activeCard == index }"
                @click.native="changeCard(index)"
              >
              </cpn-cards>
            </div>
          </div>
          <div class="card-box">
            <div class="title">{{$vi18n('$i18n# 用户数据 #i18n$')}}</div>
            <div id="card">
              <cpn-cards
                v-for="(item, index) in membersData"
                :key="index"
                :data="item"
                class="card-wrap"
                :class="{ 'active-card': activeCard == index + 2 }"
                @click.native="changeCard(index + 2)"
              >
              </cpn-cards>
            </div>
          </div>
          <div class="card-box">
            <div class="title">{{$vi18n('$i18n# 互动数据 #i18n$')}}</div>
            <div id="card">
              <cpn-cards
                v-for="(item, index) in overviewData"
                :key="index"
                :data="item"
                class="card-wrap"
                :class="{ 'active-card': activeCard == index + 6 }"
                @click.native="changeCard(index + 6)"
              >
              </cpn-cards>
            </div>
          </div>
          <div class="card-box">
            <div class="title">
              <!-- $vi18n('$i18n# 收入数据 #i18n$') -->
              <span class="help-tip">
                <!-- <template slot="header"> -->
                <el-tooltip placement="right">
                  <span>
                    {{$vi18n('$i18n# 收入数据 #i18n$')}}
                    <img
                      class="icon-help"
                      src="@/assets/images/icon_help.png"
                    />
                  </span>

                  <p slot="content" style="font-size: 16px; color: #fff">
                    {{$vi18n('$i18n# 认证成为工作室成员后归属于工作室的地图不展示收入数据 #i18n$')}}
                  </p>
                </el-tooltip>
                <!-- </template> -->
              </span>
            </div>
            <div id="card">
              <cpn-cards
                v-for="(item, index) in incomeData"
                :key="index"
                :data="item"
                class="card-wrap"
                :class="{ 'active-card': activeCard == index + 10 }"
                @click.native="changeCard(index + 10)"
              >
              </cpn-cards>
            </div>
          </div>
          <div id="charts">
            <p class="charts-title">{{$vi18n('$i18n# 自然月 #i18n$')}}{{ getChartTitle }}</p>
            <ve-line
              :extend="chartExtend"
              v-if="!isShowChartDefault"
              :data="chartData"
              :legend-visible="false"
            ></ve-line>
            <div class="img-no-data" v-else>
              <img src="../../assets/images/img_map_no_data.png" />
              <p>{{$vi18n('$i18n# 您暂时还没有数据呢 #i18n$')}}~</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- $vi18n('$i18n# 分页 #i18n$') - $vi18n('$i18n# 作品列表 #i18n$') -->

    <WorkList v-if="activeLabel"></WorkList>
    <!-- $vi18n('$i18n# 遮罩层内容 #i18n$') -->
    <Masking
      v-if="!isDeveloper"
      :height="946"
      :left="50"
      :mapType="true"
    ></Masking>
  </div>
</template>

<script>
import HelpTip from '@/components/HelpTip';
import WorkList from './workList';
import cpnCards from './components/cpn-cards.vue';
// import cpnResourceList from './components/cpn-resourceList.vue';
import { getMapAllOverview, getMapList, getMotivate } from '@/api/charts';
import Masking from '@/components/Masking';
import { mapState } from 'vuex';
import { chartExtend } from './components/chartsStyle';
import { $vi18n } from '@/utils/i18n.js';
// import {reportData} from '@/main.js'
export default {
  components: {
    HelpTip,
    WorkList,
    Masking,
    'cpn-cards': cpnCards,
    // 'cpn-resourceList': cpnResourceList
  },
  data() {
    return {
      isDeveloper: false,
      labelArr: [$vi18n('$i18n# 数据总览 #i18n$'), $vi18n('$i18n# 作品列表 #i18n$')],
      activeLabel: 0,
      overviewData: [],
      productData: [],
      incomeData: [],
      IncentData: [],
      membersData: [],
      single: {},
      numData: [],
      tableData: [],
      dayNum: 30,
      dayOptions: [
        { value: 1, label: $vi18n('$i18n# 昨日 #i18n$') },
        { value: 7, label: $vi18n('$i18n# 近七日 #i18n$') },
        { value: 30, label: $vi18n('$i18n# 近三十日 #i18n$') },
      ],
      chartData: {
        columns: [$vi18n('$i18n# 日期 #i18n$'), $vi18n('$i18n# 数据 #i18n$')],
        rows: [],
      },
      activeCard: 0,
      yesterday: '',
      startStaicDate: '',
      endStaticDate: '',
      lastWeekday: '',
      lastMonthday: '',
      chartsTitle: '',
      overviewList: [], // $vi18n('$i18n# 存储接口概览数据 #i18n$')
      monvaViewList: [], //$vi18n('$i18n# 存储激励数据 #i18n$')
      loadingCharts: false,
      loadingList: false,
      isShowChartDefault: false,
      isShowListDefault: false,
      chartExtend: chartExtend,
      dateList: [],
      // countTime: '2021.10.25'
    };
  },

  beforeDestroy() {
    this.$store.commit('SET_BACKLABEL', 0);
  },
  computed: {
    ...mapState(['userInfo']),
    getChartTitle() {
      let title1 = '';
      switch (this.activeCard) {
        case 0:
          title1 = $vi18n('$i18n# 作品浏览总次数变化 #i18n$');
          break;
        case 1:
          title1 = $vi18n('$i18n# 作品下载总次数变化 #i18n$');
          break;
        case 2:
          title1 = $vi18n('$i18n# 游戏总次数变化 #i18n$');
          break;
        case 3:
          title1 = $vi18n('$i18n# 游戏总时长（分钟）变化 #i18n$');
          break;
        case 4:
          title1 = $vi18n('$i18n# 人均游玩时长（分钟）变化 #i18n$');
          break;
        case 5:
          title1 = $vi18n('$i18n# 游戏人数变化 #i18n$');
          break;
        case 6:
          title1 = $vi18n('$i18n# 评论数变化 #i18n$');
          break;
        // case 7:
        //   title1 = $vi18n('$i18n# 投块数变化 #i18n$');
        //   break;
        case 8:
          title1 = $vi18n('$i18n# 收藏数变化 #i18n$');
          break;
        case 9:
          title1 = $vi18n('$i18n# 点赞数变化 #i18n$');
          break;
        case 10:
          title1 = $vi18n('$i18n# 广告总收入变化 #i18n$');
          break;
        case 11:
          title1 = $vi18n('$i18n# 迷你豆数量变化 #i18n$');
          break;
        case 12:
          title1 = $vi18n('$i18n# 迷你点数量变化 #i18n$');
          break;
        case 13:
          title1 = $vi18n('$i18n# 贡献点数量变化 #i18n$');
          break;
        default:
          break;
      }
      return title1;
    },
    countTime() {
      let time = '';
      time = this.startStaicDate + '-' + this.endStaicDate;
      return time;
    },
    ...mapState(['developerInfo', 'backLabel']),
  },
  created() {
    this.fetchMapOverview();
    this.Report('view', 'MapDataPage');
  },
  mounted() {
    /**$vi18n('$i18n# 判断当前日期是否小于 #i18n$')7 */
    if (new Date().getDate() < 7) {
      this.getWeekDateData();
    } else {
      this.getNatureMonthDay();
      //  this.getWeekDateData();
    }
    // if (this.dayNum === 30) {
    //   //  this.getSectionDateData();
    //   this.getNatureMonthDay();
    // } else if (this.dayNum === 7) {
    //   this.getWeekDateData();
    // } else {
    //   this.getWeekDateData();
    // }
    this.init();
  },
  methods: {
    moreClick() {
      this.activeLabel = 1;
      this.moreMapClick();
    },
    //$vi18n('$i18n# 查看更多地图点击埋点 #i18n$')
    moreMapClick() {
      this.$log('more_map_click', 85412, { v7: 1 });
    },
    init() {
      if (this.developerInfo.state == 0 || this.developerInfo.state == 3) {
        this.isDeveloper = true;
        //  this.fetchMapOverview();
        this.getYesterday();
        // this.productData = [
        //   {
        //     title: $vi18n('$i18n# 作品浏览总次数 #i18n$'),
        //     prop: 'browse',
        //     value: 500,
        //     yes: 1000,
        //   },
        //   {
        //     title: $vi18n('$i18n# 作品下载总次数 #i18n$'),
        //     prop: 'download',
        //     value: 500,
        //     yes: 1000,
        //   },
        // ];
        // this.membersData = [
        //   {
        //     title: $vi18n('$i18n# 游戏总次数 #i18n$'),
        //     prop: 'play_count',
        //     value: 500,
        //     yes: 1000,
        //   },
        //   {
        //     title: $vi18n('$i18n# 游戏总时长(分钟) #i18n$'),
        //     prop: 'play_count',
        //     value: 500,
        //     yes: 1000,
        //   },
        //   {
        //     title: $vi18n('$i18n# 次均游玩时长(分钟）#i18n$'),
        //     prop: 'play_time',
        //     value: 500,
        //     yes: 1000,
        //   },
        //   {
        //     title: $vi18n('$i18n# 游戏人数 #i18n$'),
        //     prop: 'player',
        //     value: 500,
        //     yes: 1000,
        //   },
        // ];
        // this.overviewData = [
        //   {
        //     title: $vi18n('$i18n# 评论数 #i18n$'),
        //     prop: 'comment',
        //     value: 500,
        //     yes: 1000,
        //   },
        //   // {
        //   //   title: $vi18n('$i18n# 投块数 #i18n$'),
        //   //   prop: 'block',
        //   //   value: 500,
        //   //   yes: 1000,
        //   // },
        //   {
        //     title: $vi18n('$i18n# 收藏数 #i18n$'),
        //     prop: 'collect',
        //     value: 500,
        //     yes: 1000,
        //   },
        //   {
        //     title: $vi18n('$i18n# 点赞数 #i18n$'),
        //     prop: 'praise',
        //     value: 500,
        //     yes: 1000,
        //   },
        // ];
        // this.incomeData = [
        //   {
        //     title: $vi18n('$i18n# 广告总收入 #i18n$'),
        //     prop: 'block',
        //     value: 500,
        //     yes: 1000,
        //   },
        //   {
        //     title: $vi18n('$i18n# 迷你豆数量 #i18n$'),
        //     prop: 'block',
        //     value: 500,
        //     yes: 1000,
        //   },
        //   {
        //     title: $vi18n('$i18n# 迷你点数量 #i18n$'),
        //     prop: 'block',
        //     value: 500,
        //     yes: 1000,
        //   },
        //   {
        //     title: $vi18n('$i18n# 贡献点数量 #i18n$'),
        //     prop: 'block',
        //     value: 500,
        //     yes: 1000,
        //   },
        // ];
        // this.chartsTitle = $vi18n('$i18n# 过去1日下载数变化 #i18n$');
        // this.chartData = {
        //   columns: [$vi18n('$i18n# 日期 #i18n$'), $vi18n('$i18n# 数据 #i18n$')],
        //   rows: [
        //     { [$vi18n('$i18n# 日期 #i18n$')]: '2021-03-17', [$vi18n('$i18n# 数据 #i18n$')]: 35 },
        //     { [$vi18n('$i18n# 日期 #i18n$')]: '2021-03-18', [$vi18n('$i18n# 数据 #i18n$')]: 65 },
        //     { [$vi18n('$i18n# 日期 #i18n$')]: '2021-03-19', [$vi18n('$i18n# 数据 #i18n$')]: 25 },
        //     { [$vi18n('$i18n# 日期 #i18n$')]: '2021-03-20', [$vi18n('$i18n# 数据 #i18n$')]: 85 },
        //     { [$vi18n('$i18n# 日期 #i18n$')]: '2021-03-21', [$vi18n('$i18n# 数据 #i18n$')]: 25 },
        //     { [$vi18n('$i18n# 日期 #i18n$')]: '2021-03-22', [$vi18n('$i18n# 数据 #i18n$')]: 10 },
        //     { [$vi18n('$i18n# 日期 #i18n$')]: '2021-03-23', [$vi18n('$i18n# 数据 #i18n$')]: 25 },
        //     { [$vi18n('$i18n# 日期 #i18n$')]: '2021-03-24', [$vi18n('$i18n# 数据 #i18n$')]: 85 },
        //     { [$vi18n('$i18n# 日期 #i18n$')]: '2021-03-25', [$vi18n('$i18n# 数据 #i18n$')]: 66 },
        //     { [$vi18n('$i18n# 日期 #i18n$')]: '2021-03-27', [$vi18n('$i18n# 数据 #i18n$')]: 75 },
        //     { [$vi18n('$i18n# 日期 #i18n$')]: '2021-03-28', [$vi18n('$i18n# 数据 #i18n$')]: 19 },
        //     { [$vi18n('$i18n# 日期 #i18n$')]: '2021-03-29', [$vi18n('$i18n# 数据 #i18n$')]: 24 },
        //     { [$vi18n('$i18n# 日期 #i18n$')]: '2021-03-30', [$vi18n('$i18n# 数据 #i18n$')]: 89 },
        //   ],
        // };
      } else {
        this.isDeveloper = true;
        //  this.fetchMapOverview();
        this.getYesterday();
      }
      //$vi18n('$i18n# 数据总览埋点 #i18n$')
      if (!this.activeLabel) {
        this.dataShow();
      }
      if (this.backLabel == 1) {
        this.activeLabel = this.backLabel;
      } else {
        //this.$store.commit('SET_BACKLABEL', 0);
        this.activeLabel = 0;
      }
    },
    //$vi18n('$i18n# 切换查看数据 #i18n$')
    changeLabel(index) {
      this.activeLabel = index;
      if (!this.activeLabel) {
        this.dataShow();
      } else {
        this.proListShow();
      }
    },
    //$vi18n('$i18n# 数据总览页展示埋点 #i18n$')
    dataShow() {
      this.$log('data_overview_show', 85407, { v7: 1 });
    },
    //$vi18n('$i18n# 作品列表展示埋点 #i18n$')
    proListShow() {
      this.$log('product_list_show', 85413, { v7: 1 });
    },
    //$vi18n('$i18n# 切换时间 #i18n$')
    changeDay() {
      //  this.fetchMapOverview();
      if (this.dayNum === 30) {
        this.getSectionDateData();
        //  this.getNatureMonthDay();
        this.getChartsData();
      } else if (this.dayNum === 7) {
        this.getWeekDateData();
        this.getChartsData();
      } else {
        this.getChartsData();
        this.getWeekDateData();
      }
    },
    //$vi18n('$i18n# 获取近 #i18n$')7$vi18n('$i18n# 日的年月日 #i18n$')，$vi18n('$i18n# 其他默认数据为 #i18n$')0
    getWeekDateData() {
      let arr = [];
      let startDate = new Date();
      let endDate = new Date();
      startDate.setDate(endDate.getDate() - 7);
      while (endDate.getTime() - startDate.getTime() >= 0) {
        let year = startDate.getFullYear();
        let month =
          (startDate.getMonth() + 1).toString().length === 1
            ? '0' + (startDate.getMonth() + 1).toString()
            : startDate.getMonth() + 1;
        let day =
          startDate.getDate().toString().length === 1
            ? '0' + startDate.getDate()
            : startDate.getDate();
        arr.push({
          date: year + '-' + month + '-' + day,
          block: 0,
          ad: 0,
          minibean: 0,
          minipoint: 0,
          other: 0,
          contribution: 0,
          play_avg_time: 0,
          browse: 0,
          collect: 0,
          comment: 0,
          download: 0,
          play_count: 0,
          play_time: '0',
          praise: 0,
        });
        startDate.setDate(startDate.getDate() + 1);
      }
      this.dateList = arr.slice(0, arr.length - 1);
    },

    /**
     * $vi18n('$i18n# 获取近 #i18n$')30$vi18n('$i18n# 天的年月日 #i18n$')，$vi18n('$i18n# 其他数据默认为 #i18n$')0
     */
    getSectionDateData() {
      let arr = [];
      let startDate = new Date();
      let endDate = new Date();
      startDate.setDate(endDate.getDate() - 30);
      while (endDate.getTime() - startDate.getTime() >= 0) {
        let year = startDate.getFullYear();
        let month =
          (startDate.getMonth() + 1).toString().length === 1
            ? '0' + (startDate.getMonth() + 1).toString()
            : startDate.getMonth() + 1;
        let day =
          startDate.getDate().toString().length === 1
            ? '0' + startDate.getDate()
            : startDate.getDate();
        arr.push({
          date: year + '-' + month + '-' + day,
          block: 0,
          ad: 0,
          minibean: 0,
          minipoint: 0,
          other: 0,
          contribution: 0,
          play_avg_time: 0,
          browse: 0,
          collect: 0,
          comment: 0,
          download: 0,
          play_count: 0,
          play_time: '0',
          praise: 0,
        });
        startDate.setDate(startDate.getDate() + 1);
      }
      this.dateList = arr.slice(0, arr.length - 1);
    },
    /**
     * $vi18n('$i18n# 获取自然月的年月日 #i18n$')，$vi18n('$i18n# 其他默认数据为 #i18n$')0
     * $vi18n('$i18n# 当前日期小于 #i18n$')1$vi18n('$i18n# 周展示近三天的数据 #i18n$')
     **/
    getNatureMonthDay() {
      let arr = [];
      let startDate = new Date();
      let endDate = new Date();
      startDate.setDate(endDate.getDate() - new Date().getDate() + 1);
      while (endDate.getTime() - startDate.getTime() >= 0) {
        let year = startDate.getFullYear();
        let month =
          (startDate.getMonth() + 1).toString().length === 1
            ? '0' + (startDate.getMonth() + 1).toString()
            : startDate.getMonth() + 1;
        let day =
          startDate.getDate().toString().length === 1
            ? '0' + startDate.getDate()
            : startDate.getDate();
        arr.push({
          date: year + '-' + month + '-' + day,
          block: 0,
          ad: 0,
          minibean: 0,
          minipoint: 0,
          other: 0,
          contribution: 0,
          play_avg_time: 0,
          browse: 0,
          collect: 0,
          comment: 0,
          download: 0,
          play_count: 0,
          play_time: '0',
          praise: 0,
        });
        startDate.setDate(startDate.getDate() + 1);
      }
      this.dateList = arr.slice(0, arr.length - 1);
    },
    // $vi18n('$i18n# 获取卡片数据 #i18n$')-$vi18n('$i18n# 接口 #i18n$')
    async fetchMapOverview() {
      this.loadingCharts = true;
      try {
        const res = await getMapAllOverview();
        this.overviewList =
          res.data && res.data.list && res.data.list.length
            ? res.data.list
            : [];
        //$vi18n('$i18n# 加上激励数据 #i18n$')
        if (this.monvaViewList.length) {
          //$vi18n('$i18n# 判断数据是否为空 #i18n$')
          if (!this.overviewList.length) {
            this.overviewList.push(this.monvaViewList[0]);
            for (let j = 1; j < this.monvaViewList.length; j++) {
              for (let i = 0; i < this.overviewList.length; i++) {
                if (this.overviewList[i].date == this.monvaViewList[j].date) {
                  this.overviewList[i].download =
                    (this.monvaViewList[j].download | 0) +
                    (this.overviewList[i].download | 0);
                  this.overviewList[i].play_avg_time =
                    (this.monvaViewList[j].play_avg_time | 0) +
                    (this.overviewList[i].play_avg_time | 0);
                  this.overviewList[i].play_time =
                    (this.monvaViewList[j].play_time | 0) +
                    (this.overviewList[i].play_time | 0);
                  this.overviewList[i].play_count =
                    (this.monvaViewList[j].play_count | 0) +
                    (this.overviewList[i].play_count | 0);
                  this.overviewList[i].player =
                    (this.monvaViewList[j].player | 0) +
                    (this.overviewList[i].player | 0);
                  this.overviewList[i].browse =
                    (this.monvaViewList[j].browse | 0) +
                    (this.overviewList[i].browse | 0);
                  break;
                } else {
                  this.overviewList.push(this.monvaViewList[j]);
                  break;
                }
              }
            }
          } else {
            for (let j = 0; j < this.monvaViewList.length; j++) {
              for (let i = 0; i < this.overviewList.length; i++) {
                if (this.overviewList[i].date == this.monvaViewList[j].date) {
                  this.overviewList[i].download =
                    (this.monvaViewList[j].download | 0) +
                    (this.overviewList[i].download | 0);
                  this.overviewList[i].play_avg_time =
                    (this.monvaViewList[j].play_avg_time | 0) +
                    (this.overviewList[i].play_avg_time | 0);
                  this.overviewList[i].play_time =
                    (this.monvaViewList[j].play_time | 0) +
                    (this.overviewList[i].play_time | 0);
                  this.overviewList[i].play_count =
                    (this.monvaViewList[j].play_count | 0) +
                    (this.overviewList[i].play_count | 0);
                  this.overviewList[i].player =
                    (this.monvaViewList[j].player | 0) +
                    (this.overviewList[i].player | 0);
                  this.overviewList[i].browse =
                    (this.monvaViewList[j].browse | 0) +
                    (this.overviewList[i].browse | 0);
                  break;
                } else {
                  this.overviewList.push(this.monvaViewList[j]);
                  break;
                }
              }
            }
          }
        }
        this.sumScreening();
        this.getChartsData();
        this.loadingCharts = false;
      } catch (error) {
        this.loadingCharts = false;
        console.log(error);
      }
    },
    // $vi18n('$i18n# 获取前 #i18n$')5$vi18n('$i18n# 地图数据 #i18n$')
    async fetchMapList() {
      this.loadingList = true;
      let data = {
        sort_type: 1,
        page: 1,
        page_size: 5,
      };
      try {
        const res = await getMapList(data);
        this.tableData = res.data.list;
        this.loadingList = false;
        if (this.tableData.length) {
          this.isShowListDefault = false;
        } else {
          this.isShowListDefault = true;
        }
      } catch (error) {
        this.loadingList = false;
        console.log(error);
      }
    },
    //$vi18n('$i18n# 获取全地图激励数据 #i18n$')
    async getMotivateData() {
      const time = parseInt(new Date().getTime() / 1000);
      let data = {
        time: time,
        range: 1,
      };
      const res = await getMotivate(data);
      if (res.data.ret === 0) {
        this.single = res.data.msg.all;
        let obj = res.data.msg.single; //$vi18n('$i18n# 将激励数据存进数组 #i18n$')
        for (let key in obj) {
          let time = new Date(obj[key].time * 1000);
          const year = time.getFullYear();
          const month = (time.getMonth() + 1).toString().padStart(2, '0');
          const day = time.getDate().toString().padStart(2, '0');
          this.monvaViewList.push({
            date: year + '-' + month + '-' + day,
            play_avg_time: obj[key].play_avg_time | 0,
            collect: 0,
            block: 0,
            ad: 0,
            player: obj[key].player | 0,
            minibean: 0,
            minipoint: 0,
            other: 0,
            contribution: 0,
            browse: obj[key].browse | 0,
            comment: 0,
            praise: 0,
            download: obj[key].download | 0,
            play_count: obj[key].play_count | 0,
            play_time: obj[key].play_time | 0,
          });
        }
      }
      this.fetchMapOverview();
    },
    // $vi18n('$i18n# 获取 #i18n$') '2020-04-18'$vi18n('$i18n# 格式昨日日期 #i18n$')
    getYesterday() {
      let day = new Date();
      let weekDay = new Date();
      let monthDay = new Date();
      let endDateDay = new Date();
      let lastMonthDateDay = new Date();
      day.setTime(day.getTime() - 24 * 60 * 60 * 1000);
      weekDay.setTime(weekDay.getTime() - 7 * 24 * 60 * 60 * 1000);
      monthDay.setTime(monthDay.getTime() - 30 * 24 * 60 * 60 * 1000);
      endDateDay.setTime(
        endDateDay.getTime() -
          endDateDay.getDate() * 24 * 60 * 60 * 1000 +
          24 * 60 * 60 * 1000,
      );
      lastMonthDateDay.setTime(
        lastMonthDateDay.getTime() -
          lastMonthDateDay.getDate() * 24 * 60 * 60 * 1000,
      );
      let year = day.getFullYear();
      let month =
        String(day.getMonth() + 1).length < 2
          ? '0' + (day.getMonth() + 1)
          : day.getMonth() + 1;
      let month1 =
        String(monthDay.getMonth() + 1).length < 2
          ? '0' + (monthDay.getMonth() + 1)
          : monthDay.getMonth() + 1;
      let yesMonth =
        String(monthDay.getMonth() + 1).length < 2
          ? '0' + (monthDay.getMonth() + 1)
          : monthDay.getMonth() + 1;
      let date =
        String(day.getDate()).length < 2 ? '0' + day.getDate() : day.getDate();
      let date1 =
        String(weekDay.getDate()).length < 2
          ? '0' + weekDay.getDate()
          : weekDay.getDate();
      let date2 =
        String(monthDay.getDate()).length < 2
          ? '0' + monthDay.getDate()
          : monthDay.getDate();
      let date3 =
        String(lastMonthDateDay.getDate()).length < 2
          ? '0' + lastMonthDateDay.getDate()
          : lastMonthDateDay.getDate();
      let date4 =
        String(endDateDay.getDate()).length < 2
          ? '0' + endDateDay.getDate()
          : endDateDay.getDate();
      let date5 = '01';
      this.yesterday = year + '.' + month + '.' + date;
      this.yesterday1 = year + '-' + month + '-' + date;
      this.lastWeekday = year + '.' + month + '.' + date1; //$vi18n('$i18n# 一周前 #i18n$')
      this.lastMonthday = year + '.' + month1 + '.' + date2; //$vi18n('$i18n# 一个月前 #i18n$')
      //$vi18n('$i18n# 判断当前日期是否是 #i18n$')1$vi18n('$i18n# 号 #i18n$')，1$vi18n('$i18n# 号则统计周期为上个月 #i18n$')
      if (new Date().getDate() === 1) {
        this.startStaicDate = year + '.' + yesMonth + '.' + date5;
        this.endStaicDate = year + '.' + yesMonth + '.' + date3;
      } else {
        this.startStaicDate = year + '.' + month + '.' + date4;
        this.endStaicDate = year + '.' + month + '.' + date;
      }
    },
    // $vi18n('$i18n# 求和 #i18n$')/$vi18n('$i18n# 筛选昨日数据 #i18n$')
    sumScreening() {
      //$vi18n('$i18n# 下载数 #i18n$')
      let downloadSum = this.overviewList.reduce((sum, current) => {
        return sum + Number(current.download);
      }, 0);
      //downloadSum = downloadSum + (this.single.download | 0);
      //$vi18n('$i18n# 浏览数 #i18n$')
      let browseSum = this.overviewList.reduce((sum, current) => {
        return sum + Number(current.browse);
      }, 0);
      //$vi18n('$i18n# 游玩次数 #i18n$')
      let playCountSum = this.overviewList.reduce((sum, current) => {
        return sum + Number(current.play_count);
      }, 0);
      //playCountSum = playCountSum + (this.single.play_count | 0);
      //$vi18n('$i18n# 游玩总时间 #i18n$')
      let playTimeSum = this.overviewList.reduce((sum, current) => {
        return sum + Number(current.play_time);
      }, 0);
      //playTimeSum = playTimeSum + (this.single.play_time | 0);
      //$vi18n('$i18n# 人均游玩时长 #i18n$')
      // let playAvgTimeSum = this.overviewList.reduce((sum, current) => {
      //   return sum + Number(current.play_avg_time);
      // }, 0);
      let playAvgTimeSum;
      if (playTimeSum) {
        playAvgTimeSum = playTimeSum / playCountSum;
      } else {
        playAvgTimeSum = 0;
      }
      // playAvgTimeSum = playAvgTimeSum + (this.single.play_avg_time | 0);
      //$vi18n('$i18n# 广告总收入 #i18n$')
      let adSum = this.overviewList.reduce((sum, current) => {
        return sum + Number(current.ad);
      }, 0);
      //$vi18n('$i18n# 点赞数 #i18n$')
      // let praiseSum = this.overviewList.reduce((sum, current) => {
      //   return sum + Number(current.praise);
      // }, 0);
      //$vi18n('$i18n# 迷你豆 #i18n$')
      let minibeanSum = this.overviewList.reduce((sum, current) => {
        return sum + Number(current.minibean);
      }, 0);
      //$vi18n('$i18n# 迷你点 #i18n$')
      let minipointSum = this.overviewList.reduce((sum, current) => {
        return sum + Number(current.minipoint);
      }, 0);
      //$vi18n('$i18n# 其他收入 #i18n$')
      // let otherSum = this.overviewList.reduce((sum, current) => {
      //   return sum + Number(current.other);
      // }, 0);
      //$vi18n('$i18n# 评论数 #i18n$')
      let commentSum = this.overviewList.reduce((sum, current) => {
        return sum + Number(current.comment);
      }, 0);
      //$vi18n('$i18n# 投块数 #i18n$')
      let blockSum = this.overviewList.reduce((sum, current) => {
        return sum + Number(current.block);
      }, 0);
      //$vi18n('$i18n# 收藏数 #i18n$')
      let collectSum = this.overviewList.reduce((sum, current) => {
        return sum + Number(current.collect);
      }, 0);
      //$vi18n('$i18n# 点赞数 #i18n$')
      let praiseSum = this.overviewList.reduce((sum, current) => {
        return sum + Number(current.praise);
      }, 0);
      //collectSum = collectSum + (this.single.collect | 0);
      //$vi18n('$i18n# 贡献点 #i18n$')
      let contributionSum = this.overviewList.reduce((sum, current) => {
        return sum + Number(current.contribution);
      }, 0);
      //$vi18n('$i18n# 游戏总人数 #i18n$')
      let Player = this.overviewList.reduce((sum, current) => {
        return sum + Number(current.player);
      }, 0);
      let yesData = this.overviewList.find(n => {
        return n.date == this.yesterday1;
      });

      let yesOjb = yesData ? yesData : {};
      this.productData = [
        {
          title: $vi18n('$i18n# 作品浏览总次数 #i18n$'),
          prop: 'browse',
          value: browseSum,
          yes: yesOjb.browse | 0,
        },
        {
          title: $vi18n('$i18n# 作品下载总次数 #i18n$'),
          prop: 'download',
          value: downloadSum,
          yes: yesOjb.download | 0,
        },
      ];
      this.membersData = [
        {
          title: $vi18n('$i18n# 游戏总次数 #i18n$'),
          prop: 'play_count',
          value: playCountSum,
          yes: yesOjb.play_count | 0,
        },
        {
          title: $vi18n('$i18n# 游戏总时长(分钟) #i18n$'),
          prop: 'play_time',
          value: playTimeSum / 60,
          yes: (yesOjb.play_time | 0) / 60,
        },
        {
          title: $vi18n('$i18n# 次均游玩时长(分钟) #i18n$'),
          prop: 'play_avg_time',
          value: playAvgTimeSum / 60,
          yes: (yesOjb.play_avg_time | 0) / 60,
        },
        {
          title: $vi18n('$i18n# 游戏人数 #i18n$'),
          prop: 'player',
          value: Player,
          yes: yesOjb.player | 0,
        },
        // {
        //   title: '$vi18n('$i18n# 新增用户数 #i18n$')',
        //   prop: 'comment',
        //   value: commentSum,
        //   yes: yesOjb.comment | 0
        // }
      ];
      this.overviewData = [
        {
          title: $vi18n('$i18n# 评论数 #i18n$'),
          prop: 'comment',
          value: commentSum,
          yes: yesOjb.comment | 0,
        },
        // {
        //   title: $vi18n('$i18n# 投块数 #i18n$'),
        //   prop: 'block',
        //   value: blockSum,
        //   yes: yesOjb.block | 0,
        // },
        {
          title: $vi18n('$i18n# 收藏数 #i18n$'),
          prop: 'collect',
          value: collectSum,
          yes: yesOjb.collect | 0,
        },
        {
          title: $vi18n('$i18n# 点赞数 #i18n$'),
          prop: 'praise',
          value: praiseSum,
          yes: yesOjb.praise | 0,
        },
      ];
      this.incomeData = [
        {
          title: $vi18n('$i18n# 广告总收入 #i18n$'),
          prop: 'ad',
          value: adSum,
          yes: yesOjb.ad | 0,
        },
        {
          title: $vi18n('$i18n# 迷你豆数量 #i18n$'),
          prop: 'minibean',
          value: minibeanSum,
          yes: yesOjb.minibean | 0,
        },
        {
          title: $vi18n('$i18n# 迷你点数量 #i18n$'),
          prop: 'minipoint',
          value: minipointSum,
          yes: yesOjb.minipoint | 0,
        },
        {
          title: $vi18n('$i18n# 贡献点数量 #i18n$'),
          prop: 'contribution',
          value: contributionSum,
          yes: yesOjb.contribution | 0,
        },
        // {
        //   title: '$vi18n('$i18n# 其他收入 #i18n$')',
        //   prop: 'other',
        //   value: otherSum,
        //   yes: yesOjb.other | 0
        // }
      ];
      //$vi18n('$i18n# 合并多个数组 #i18n$')
      this.numData = this.productData
        .concat(this.membersData)
        .concat(this.overviewData)
        .concat(this.incomeData);
    },
    // $vi18n('$i18n# 计算图表数据 #i18n$')
    getChartsData() {
      this.chartData.rows = [];
      // if (this.overviewData[this.activeCard].value != 0) {
      // this.isShowChartDefault = false;
      this.chartsTitle = this.numData[this.activeCard].title;
      // if (this.activeCard <= 3) {
      //   this.chartsTitle = this.productData[this.activeCard].title;
      // } else if (this.activeCard <= 8) {
      //   this.chartsTitle = this.membersData[this.activeCard - 4].title;
      // } else if (this.activeCard <= 11) {
      //   this.chartsTitle = this.overviewData[this.activeCard - 9].title;
      // } else {
      //   this.chartsTitle = this.incomeData[this.activeCard - 12].title;
      // }
      this.dateList.forEach(date => {
        this.overviewList.forEach(item => {
          if (date.date == item.date) {
            date = item;
          }
        });
        const _prop = this.numData[this.activeCard].prop;
        this.chartData.rows.push({
         [$vi18n('$i18n# 日期 #i18n$')]: date.date,
          [$vi18n('$i18n# 数据 #i18n$')]:
            _prop == 'play_time' || _prop == 'play_avg_time'
              ? Number(date[_prop] / 60).toFixed(2)
              : date[_prop],
        });
      });
    },
    // $vi18n('$i18n# 切换卡片 #i18n$')
    changeCard(index) {
      this.activeCard = index;
      this.getChartsData();
      this.moduleClick(index);
    },
    //$vi18n('$i18n# 数据模块点击埋点 #i18n$')
    moduleClick(index) {
      this.$log('data_module_show', 85410, { v7: 1, v8: index + 1 });
    },
  },
};
</script>

<style lang="scss" scoped>
$--color-primary: #fd9b21;

#main {
  display: flex;
  flex-flow: column;
  width: 100%;
  min-height: 100%;
  background-color: white;
  border-radius: 8px;
  //padding: 20px 33px 40px 33px;
  padding: 20px 33px 40px 33px;
}

#tab {
  margin-bottom: 18px;
  border-bottom: 1px solid #ddd;
  display: flex;
  align-items: center;
  .btn-label {
    font-size: 20px;
    color: #595959;
    padding-bottom: 10px;
    cursor: pointer;
  }
  .btn-label:nth-child(1) {
    margin-right: 32px;
  }

  .p-chosen {
    border-bottom: 4px solid $--color-primary;
    cursor: initial;
    position: relative;
    &:before {
      display: block;
      content: '';
      width: 0;
      border-width: 4px;
      border-style: solid;
      border-color: transparent transparent $--color-primary transparent;
      position: absolute;
      left: 50%;
      margin-left: -2px;
      bottom: 0;
    }
  }
}

#card {
  display: flex;
  justify-content: flex-start;
  //justify-content: space-between;
  flex-wrap: wrap;
  cursor: pointer;
  .chosen {
    border: 4px solid #bbb;
    background-color: #fbeded;
    &::after {
      content: '';
      position: absolute;
      bottom: -4px;
      right: -4px;
      width: 0;
      height: 0;
      border: 15px solid;
      border-left-color: transparent;
      border-right-color: #bbb;
      border-top-color: transparent;
      border-bottom-color: #bbb;
    }
  }
}

#charts {
  min-height: 200px;
  .charts-title {
    font-size: 14px;
    color: #8c8c8c;
  }
}

#resource-data {
  display: flex;
  flex-flow: column;
  & > div {
    display: flex;
  }
  .map-title {
    font-size: 24px;
    margin-bottom: 22px;
  }
  .map-card-list {
    display: flex;
    flex-direction: column;
  }
}

#overview {
  .card-content {
    margin-bottom: 30px;
    .card-title {
      margin-bottom: 16px;
      .title-help {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 8px;
        .name {
          font-size: 24px;
          color: #262626;
        }
        .help {
          .help-tip {
            display: flex;
            justify-content: flex-end;
          }
          .data-filter {
            display: flex;
            align-items: center;
            justify-content: flex-end;
            margin-top: 8px;
            .desc {
              color: #262626;
              margin-right: 2px;
            }
            .data-select {
              width: 86px;
              height: 36px;
              ::v-deep .el-input.el-input--small.el-input--suffix {
                border: none;
              }
            }
          }
          .week-filter {
            display: flex;
            align-items: center;
            margin-top: 10px;
            justify-content: flex-end;
            color: #8c8c8c;
            .desc {
              color: #8c8c8c;
              margin-right: 2px;
            }
            .data-select {
              width: 86px;
              height: 36px;
              ::v-deep .el-input.el-input--small.el-input--suffix {
                border: none;
              }
            }
          }
        }
      }
      p {
        color: #8c8c8c;
      }
      .day-title {
        margin-top: -5px;
      }
    }
    .card-box {
      .container {
        width: 190px;
      }
    }
  }
  .card-wrap {
    margin-left: 10px;
    //width: 180px;
    // &:nth-child(4n) {
    //   margin-right: 0;
    // }
    &:hover {
      background: #fffaed;
      border: 1px solid #ffc973;
    }
  }
  .card-wrap:first-child {
    margin-left: 0;
  }

  .active-card {
    background: #fffaed;
  }
  .btn-more-map {
    color: $--color-primary;
    width: 130px;
    height: 36px;
    font-size: 16px;
    border-radius: 18px;
    border: 1px solid #ffc973;
    background: #fffaed;
    cursor: pointer;
    text-align: center;
    line-height: 36px;
  }
}
.img-no-data {
  margin-top: 20px;
  text-align: center;
  background: url('../../assets/images/img_bg_charts_no_data.png') no-repeat;
  height: 218px;
  img {
    margin-top: -30px;
    width: 160px;
    height: 160px;
  }
  p {
    font-size: 16px;
    color: #8c8c8c;
  }
}
.img-map-no-data {
  text-align: center;
  img {
    width: 160px;
    height: 160px;
  }
  p {
    font-size: 16px;
    color: #8c8c8c;
  }
}
.complex-wrap {
  min-height: 574px;
  .card-box {
    .title {
      margin-bottom: 10px;
      font-size: 16px;
    }
    img.icon-help {
      height: 10px;
      width: 10px;
      margin-left: 3px;
    }
  }
}
.mask {
  position: relative;
}
</style>
